import React from 'react';

interface Publication {
  title: string;
  authors: string;
  // journal: string;
  year: number;
  link: string;
  featured?: boolean;
}

interface PublicationCardProps {
  publication: Publication;
  isFeatured: boolean;
}

const PublicationCard: React.FC<PublicationCardProps> = ({ publication, isFeatured }) => {
  return (
    <div className={`${isFeatured ? 
      'bg-gradient-to-r from-blue-600 to-blue-800 text-white rounded-lg shadow-xl' : 
      'bg-white shadow-md rounded-lg'} 
      overflow-hidden h-full transition-transform duration-300 hover:scale-[1.02]`}
    >
      <div className="p-6 h-full flex flex-col">
        <h3 className={`text-lg ${isFeatured ? 'text-white' : 'text-gray-900'} font-bold mb-2`}>
          {publication.title}
        </h3>
        <p className={`${isFeatured ? 'text-blue-100' : 'text-gray-600'} mb-2`}>
          {publication.authors}
        </p>
        <p className={`${isFeatured ? 'text-blue-200' : 'text-gray-500'} text-sm mb-4`}>
           {publication.year}
        </p>
        <div className="mt-auto">
          <a
            href={publication.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`inline-block ${
              isFeatured ? 
                'bg-white text-blue-600 hover:bg-gray-100' : 
                'bg-blue-50 text-blue-600 hover:bg-blue-100'
            } px-4 py-2 rounded-md font-medium text-sm transition-colors`}
          >
            View Publication
          </a>
        </div>
      </div>
    </div>
  );
};

export default PublicationCard;